import { SelectFactory, SelectTypes } from '@g17eco/molecules/select/SelectFactory';
import { useAppSelector } from '@reducers/index';
import { getRootConfig } from '@selectors/globalData';
import { FeaturePermissions } from '@services/permissions/FeaturePermissions';
import { ViewValues } from '@g17eco/types/surveyOverview';
import { ViewMap, ViewScopeType } from '@constants/viewOptions';

interface Props {
  view: ViewValues;
  onChangeView: (view: ViewValues) => void;
}

const getViewOptions = (showWorkgroup: boolean) => {
  return [
    ViewValues.Users,
    ...(showWorkgroup ? [ViewValues.Workgroups] : []),
    ViewValues.StandardsAndFrameworks,
    ViewValues.Sdg,
    ViewValues.Custom,
    ViewValues.AssignedMetrics,
  ].map((k: ViewValues) => ViewMap[k]);
};

export const ViewDropdown = ({ view, onChangeView }: Props) => {
  const rootConfig = useAppSelector(getRootConfig);
  const workgroupsLimit = FeaturePermissions.getLimitWorkgroups(rootConfig);
  const viewOptions: ViewScopeType = getViewOptions(workgroupsLimit > 0);

  const value = viewOptions.find((o) => o.value === view);

  return (
    <SelectFactory<ViewValues>
      selectType={SelectTypes.SingleSelect}
      placeholder='Select view'
      options={viewOptions}
      value={value}
      onChange={(selection) => (selection ? onChangeView(selection.value) : undefined)}
      isSearchable={false}
      backgroundColor={'var(--theme-BgExtralight)'}
    />
  );
};
